import s from './Arrow.module.scss';

export default function Arrow({ open, onClick }) {
  return (
    <div onClick={onClick} className={s.wrapper}>
      <span>Details</span>
      {open ? (
        <i className="material-icons">keyboard_arrow_up</i>
      ) : (
        <i className="material-icons">keyboard_arrow_down</i>
      )}
    </div>
  );
}
